export default __webpack_public_path__ + "static/06.04-63b65b7cd4a6669f90af81df8f0ee5c1.png";